export default __webpack_public_path__ + "static/media/jia.ce517ca6.gif";